/* Keep Dawn's gallery, variant fetch, zoom and video controls; filter its media by color. */
(() => {
  if (window.rs2GalleryLoaded) return;
  window.rs2GalleryLoaded = true;
  const initialized = new WeakSet();
  document.addEventListener('click', event => {
    const link = event.target.closest('.rs-size-scroll-link');
    if (!link) return;
    const headings = [...document.querySelectorAll('.motif-header h2')];
    const heading = headings.find(node => /gr[öo]sse|größe|size.*fit/i.test(node.textContent));
    const header = heading?.closest('.motif-header');
    if (!header) return;
    event.preventDefault();
    header.id = 'groesse-und-passform';
    const panel = header.nextElementSibling;
    if (panel && panel.getBoundingClientRect().height === 0) header.click();
    header.scrollIntoView({behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block:'center'});
  });
  function modelForColor(images, variants, variant) {
    if (!variant) return null;
    const models = images.filter(media => media.isModel);
    if (!models.length) return null;
    const colors = [...new Set(variants.map(item => item.color).filter(Boolean))];
    const index = Math.max(0, colors.indexOf(variant.color));
    return models.find(media => media.id === variant.media) ||
      models.find(media => media.modelGender === (index % 2 ? 'female' : 'male')) || models[index % models.length];
  }
  function initialize() {
    document.querySelectorAll('media-gallery[data-rs2-color-gallery]').forEach((gallery) => {
      if (initialized.has(gallery)) return;
      const dataNode = gallery.querySelector('[data-rs2-gallery-data]');
      if (!dataNode) return;
      const data = JSON.parse(dataNode.textContent);
      const hydrate = (root) => {
        root?.querySelectorAll('img[data-rs2-src]').forEach(image => {
          if (image.dataset.rs2Srcset) image.srcset = image.dataset.rs2Srcset;
          image.src = image.dataset.rs2Src;
          image.removeAttribute('data-rs2-src');
          image.removeAttribute('data-rs2-srcset');
        });
      };
      const setActiveMedia = gallery.setActiveMedia?.bind(gallery);
      if (setActiveMedia) gallery.setActiveMedia = (id, prepend) => {
        hydrate(gallery.querySelector(`[data-media-id="${id}"]`));
        return setActiveMedia(id, prepend);
      };
      const modal = document.getElementById(`ProductModal-${gallery.dataset.sectionId}`);
      modal?.addEventListener('click', () => hydrate(modal));
      gallery.addEventListener('click', event => {
        if (event.target.closest('.product__media-toggle')) hydrate(modal);
      }, true);

      const anchors = new Map();
      for (const variant of data.variants) {
        if (!variant.media || !variant.color) continue;
        if (!anchors.has(String(variant.media))) anchors.set(String(variant.media), new Set());
        anchors.get(String(variant.media)).add(variant.color);
      }
      // Shopify's media order groups each color behind its variant featured image.
      // Without two anchors, keep every image and use the second product image.
      const grouped = anchors.size >= 2;
      const groups = new Map();
      let colors = null;
      for (const media of data.media) {
        if (anchors.has(String(media.id))) colors = anchors.get(String(media.id));
        groups.set(String(media.id), grouped && media.type === 'image' ? colors : null);
      }
      const detailButton = gallery.querySelector('[data-rs2-gallery-detail]');
      let detailId = null;
      let applied = false;
      let appliedColor;
      let selectedMedia = null;
      let explicitSelection = false;
      let applying = false;
      const placeDetailButton = (active) => {
        if (!detailButton) return;
        const container = active?.querySelector('.product-media-container.media-type-image');
        detailButton.hidden = detailId === null || !container;
        if (container && detailButton.parentElement !== container) container.append(detailButton);
      };
      const apply = (variant) => {
        applying = true;
        const colorChanged = !applied || (variant && variant.color !== appliedColor);
        if (colorChanged && applied) explicitSelection = true;
        if (variant) {
          applied = true;
          appliedColor = variant.color;
        }
        if (colorChanged) selectedMedia = null;
        const colorVisible = (id) => !variant || !groups.get(id) || groups.get(id).has(variant.color);
        const images = data.media.filter(media => media.type === 'image' && colorVisible(String(media.id)));
        const model = modelForColor(images, data.variants, variant);
        const otherModels = new Set(model ? images.filter(media => media.isModel && media.id !== model.id).map(media => String(media.id)) : []);
        const visible = (id) => colorVisible(id) && !otherModels.has(id);
        gallery.querySelectorAll('[data-media-id], [data-target]').forEach((item) => {
          const id = (item.dataset.mediaId || item.dataset.target).split('-').pop();
          item.classList.toggle('rs2-media-hidden', !visible(id));
          if (visible(id)) hydrate(item);
        });
        const modal = document.getElementById(`ProductModal-${gallery.dataset.sectionId}`);
        modal?.querySelectorAll('[data-media-id]').forEach((item) => {
          item.classList.remove('product__media-item--variant');
          item.classList.toggle('rs2-media-hidden', !visible(item.dataset.mediaId));
        });
        const detail = images.find(media => media.stitchDetail) || (data.isCap ? null : images.find(media => media.id !== variant?.media && !media.isModel));
        detailId = detail?.id ?? null;
        if (detailButton) {
          detailButton.hidden = detailId === null;
          detailButton.disabled = detailId === null;
        }
        if (data.modelFirst && model) {
          for (const selector of ['[id^="Slider-Gallery"]', '[id^="Slider-Thumbnails"]']) {
            const list = gallery.querySelector(selector);
            const itemFor = id => list?.querySelector(`[data-media-id="${gallery.dataset.sectionId}-${id}"], [data-target="${gallery.dataset.sectionId}-${id}"]`);
            const first = itemFor(model.id);
            const second = detail && itemFor(detail.id);
            if (first && list.firstElementChild !== first) list.prepend(first);
            if (second && first?.nextElementSibling !== second) first.after(second);
          }
        }
        gallery.querySelectorAll('slider-component').forEach((slider) => slider.resetPages?.());
        const firstId = data.modelFirst && model ? model.id : variant?.media;
        if (colorChanged && firstId) selectedMedia = `${gallery.dataset.sectionId}-${firstId}`;
        const targetId = selectedMedia;
        applying = false;
        if (!targetId) {
          placeDetailButton(gallery.querySelector('[data-media-id].is-active'));
          return;
        }
        const active = gallery.querySelector(`[data-media-id="${targetId}"]`);
        if (active) gallery.setActiveMedia?.(active.dataset.mediaId, false);
        placeDetailButton(active || gallery.querySelector('[data-media-id].is-active'));
      };
      detailButton?.addEventListener('click', () => {
        if (detailId === null) return;
        selectedMedia = `${gallery.dataset.sectionId}-${detailId}`;
        gallery.setActiveMedia?.(selectedMedia, false);
      });
      // Dawn resets featured media before publishing even a same-colour size change.
      gallery.addEventListener('click', (event) => {
        const thumbnail = event.target.closest('[data-target]');
        if (thumbnail) {
          selectedMedia = thumbnail.dataset.target;
          // Variant updates can replace the buttons Dawn bound on initial load.
          if (gallery.querySelector('[data-media-id].is-active')?.dataset.mediaId !== selectedMedia) {
            gallery.setActiveMedia?.(selectedMedia, false);
          }
        }
      });
      initialized.add(gallery);
      apply(data.variants.find((variant) => variant.id === data.selected));
      gallery.addEventListener('click', event => { explicitSelection = !!event.target.closest('[data-target], [data-rs2-gallery-detail]'); }, true);
      let lastMedia = gallery.querySelector('[data-media-id].is-active')?.dataset.mediaId;
      let cancelReveal = () => {};
      const reveal = (active) => {
        placeDetailButton(active);
        if (!active || active.dataset.mediaId === lastMedia) return;
        lastMedia = active.dataset.mediaId;
        cancelReveal();
        const image = active.querySelector('.product__modal-opener--image img');
        // Native mobile scrolling owns its transition; never hide a photo after it loaded.
        const mobileSwipe = matchMedia('(max-width: 749px)').matches && !explicitSelection;
        explicitSelection = false;
        if (!image?.complete || !image.naturalWidth || mobileSwipe) return;
        cancelReveal = window.rs2DitherReveal?.(image, 420) || (() => {});
      };
      // Observe native selection, including listeners bound before this script loaded.
      const observer = new MutationObserver(() => reveal(gallery.querySelector('[data-media-id].is-active')));
      observer.observe(gallery.querySelector('[id^="Slider-Gallery"]'), { subtree: true, attributes: true, attributeFilter: ['class'] });
      gallery.querySelector('[id^="GalleryViewer"]')?.addEventListener('slideChanged', (event) => {
        if (applying) return;
        const active = event.detail.currentElement;
        if (!active || active.classList.contains('rs2-media-hidden')) return;
        selectedMedia = active.dataset.mediaId;
        gallery.querySelectorAll('[id^="Slider-Gallery"] > [data-media-id]').forEach((item) => {
          item.classList.toggle('is-active', item === active);
        });
        reveal(active);
      });
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        const unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
          if (!gallery.isConnected) { unsubscribe(); observer.disconnect(); cancelReveal(); return; }
          if (event.data.sectionId !== gallery.dataset.sectionId) return;
          apply(data.variants.find((variant) => variant.id === event.data.variant?.id));
        });
      }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, { once: true });
  else initialize();
  document.addEventListener('shopify:section:load', initialize);
})();
